import { render, staticRenderFns } from "./Personal.vue?vue&type=template&id=2c6653aa&"
import script from "./Personal.vue?vue&type=script&lang=js&"
export * from "./Personal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports